<template>
    <div class="zip-cta">
        <div class="d-inline-flex flex-column p-3 p-sm-4 bg-white border border-gray-200 rounded card-shadow">
            <div
                v-if="showEsBanner"
                class="
                     d-flex flex-column flex-sm-row text-center text-sm-left align-items-center mb-4"
            >
                <EsLogo />
                <h2 class="banner-text mb-0 mt-2 mt-sm-0 ml-sm-4">
                    Explore your solar options
                </h2>
            </div>
            <!-- eslint-disable-next-line max-len -->
            <div
                v-if="showHeader"
                class="h4 mb-2"
            >
                {{ headlineCopy }}
            </div>
            <div
                v-if="showSubHeader"
                class="sub-header-text mb-3 text-md-left text-center text-wrap"
            >
                {{ subHeaderCopy }}
            </div>

            <form
                ref="ctaForm"
                method="GET"
                class="mb-0 d-sm-flex flex-sm-row"
            >
                <div v-if="rc">
                    <input
                        name="rc"
                        type="hidden"
                        :value="rc"
                    >
                </div>
                <!-- Zip entry section -->
                <div
                    class="d-block"
                >
                    <label
                        :for="zipCodeInputId"
                        class="d-flex text-gray-800 bold-label align-items-center mr-3 mb-0"
                    >
                        Enter your zip code
                    </label>

                    <div
                        class="flex-grow-1 pr-sm-3 sm-set-width"
                    >
                        <es-input
                            :id="zipCodeInputId"
                            v-model="zipCode"
                            name="zip_code"
                            input-class="zip-entry bg-gray-100 border-gray-500"
                            :validator="$v.zipCode"
                            placeholder="5-digit zip code"
                        >
                            <template #afterInput>
                                <location-icon
                                    class="location-icon"
                                    aria-hidden="true"
                                />
                            </template>
                            <template #validationText>
                                This field is Required
                            </template>
                        </es-input>
                    </div>
                </div> <!-- Zip entry section -->

                <!-- Rooftop button -->
                <div
                    class="d-flex flex-column flex-sm-row pt-3 align-items-sm-end"
                >
                    <es-button
                        class="ctaButton flex-grow-1"
                        @click.prevent="handleRooftopBtn"
                    >
                        Explore Rooftop Solar
                    </es-button>
                </div> <!-- Rooftop button -->
            </form>

            <div
                v-if="scrollToCompareLink"
                class="mt-3"
            >
                <a :href="scrollToCompareLink">
                    Which solution is right for me?
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators';
import EsInput from '@/components/EsInput';
import EsButton from '@/components/EsButton';
import { validationMixin } from '@/utils/mixins';
import { makeIdUnique } from '@/utils/functions';
import LocationIcon from '@/components/icons/LocationIcon';
import EsLogo from '@/components/icons/EsLogo';

const ROOFTOP_URL = 'https://www.energysage.com/market/start/';

export default {
    components: {
        EsInput,
        EsButton,
        LocationIcon,
        EsLogo,
    },
    mixins: [validationMixin],
    props: {
        headlineCopy: {
            type: String,
            default: 'Want Free Quotes?',
            required: false,
        },
        showHeader: {
            type: Boolean,
            default: true,
            required: false,
        },
        subHeaderCopy: {
            type: String,
            // eslint-disable-next-line max-len
            default: "EnergySage is the country's most trusted solar shopping resource. They'll help you compare your options for solar.",
            required: false,
        },
        showSubHeader: {
            type: Boolean,
            default: false,
            required: false,
        },
        scrollToCompareLink: {
            type: String,
            default: '',
            required: false,
        },
        showEsBanner: {
            type: Boolean,
            default: false,
            required: false,
        },
        rc: {
            type: String,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            zipCode: '',
            zipCodeInputId: makeIdUnique('zip_code'),
        };
    },
    validations: {
        zipCode: {
            required,
            minLength: minLength(5),
        },
    },
    methods: {
        handleRooftopBtn() {
            this.$refs.ctaForm.action = `${ROOFTOP_URL}`;
            this.$refs.ctaForm.submit();
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/sass/bs4/_helpers.scss";

.zip-cta {
    :deep() {
        @import "@/sass/widgets.scss";
        font-family: $font-family-sans-serif;
        font-size: $font-size-base;
    }

    .h4 {
        font-size: 18px;
    }
}

:deep(.zip-entry) {
    font-family: $font-family-sans-serif!important;
    font-size: 16px!important;
}

.sm-set-width {
    @include media-breakpoint-up(sm) {
        width: 220px;
    }
}

:deep(.form-group) {
    margin-bottom: 0!important;
}

.card-shadow {
    box-shadow: 4px 5px 8px 0 rgba(86, 86, 86, 0.17);
}

.ctaButton {
    @include media-breakpoint-up(sm) {
        width: 220px;
    }
}

.bold-label {
    font-weight: bold;
}

.location-icon {
    position: absolute;
    right: 8px;
}

.banner-text {
    @include media-breakpoint-up(sm) {
        max-width: 340px;
    }
}

.sub-header-text {
    @include media-breakpoint-up(sm) {
        max-width: 480px;
    }

    @include media-breakpoint-up(xs) {
        max-width: 270px;
    }
}

</style>
